import { Usuario, UsuarioAutenticado } from '@/modules/auth/models/usuario.model';

type UsuarioApi = Usuario & Record<string, unknown>;

function pickString(source: Record<string, unknown>, ...keys: string[]): string {
    for (const key of keys) {
        const value = source[key];
        if (typeof value === 'string' && value.trim()) {
            return value;
        }
    }
    return '';
}

function pickNumber(source: Record<string, unknown>, ...keys: string[]): number {
    for (const key of keys) {
        const value = source[key];
        if (typeof value === 'number' && !Number.isNaN(value)) {
            return value;
        }
    }
    return 0;
}

export function getLoginAD(usuario?: Usuario | null): string {
    if (!usuario) {
        return '';
    }
    const raw = usuario as UsuarioApi;
    return (usuario.loginAD || (raw.LoginAD as string) || '').trim();
}

export function hasValidLoginAD(usuario?: Usuario | null): boolean {
    return getLoginAD(usuario).length > 0;
}

function mapApiUsuarioFields(usuario: UsuarioApi): Usuario {
    if (!usuario.loginAD && typeof usuario.LoginAD === 'string') {
        usuario.loginAD = usuario.LoginAD;
    }
    if (!usuario.nome && typeof usuario.Nome === 'string') {
        usuario.nome = usuario.Nome;
    }
    if (!usuario.arvoreMenu && Array.isArray(usuario.ArvoreMenu)) {
        usuario.arvoreMenu = usuario.ArvoreMenu as Usuario['arvoreMenu'];
    }

    const apiAuth = usuario.UsuarioAutenticado as UsuarioAutenticado | Record<string, unknown> | undefined;
    if (apiAuth && !usuario.usuarioAutenticado?.cpfCnpj) {
        const auth = apiAuth as Record<string, unknown>;
        const typed = apiAuth as UsuarioAutenticado;
        usuario.usuarioAutenticado = {
            ...new UsuarioAutenticado(),
            login: typed.login || pickString(auth, 'Login'),
            cpfCnpj: typed.cpfCnpj || pickString(auth, 'CpfCnpj'),
            nomeCompleto: typed.nomeCompleto || pickString(auth, 'NomeCompleto'),
            email: typed.email || pickString(auth, 'Email'),
            matricula: typed.matricula || pickNumber(auth, 'Matricula'),
            selo: typed.selo || pickNumber(auth, 'Selo'),
            seloDescricao: typed.seloDescricao || pickString(auth, 'SeloDescricao'),
            tipoUltimoAcessoId: typed.tipoUltimoAcessoId || pickNumber(auth, 'TipoUltimoAcessoId'),
            tipoUltimoAcessoDescricao:
                typed.tipoUltimoAcessoDescricao || pickString(auth, 'TipoUltimoAcessoDescricao'),
        };
    }

    return usuario;
}

export function alterarCampoCpfComBaseNoLoginAD(loginInfo: Usuario): string {
    if (loginInfo.usuarioAutenticado?.cpfCnpj?.trim()) {
        return loginInfo.usuarioAutenticado.cpfCnpj;
    }

    const loginAD = getLoginAD(loginInfo);
    const regex =
        /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/i;
    const result = loginAD.match(regex);

    if (result) {
        return loginAD;
    }

    return '';
}

export function normalizeUsuarioSessao(usuario: Usuario): Usuario {
    const mapped = mapApiUsuarioFields(usuario as UsuarioApi);

    if (!mapped.usuarioAutenticado) {
        mapped.usuarioAutenticado = new UsuarioAutenticado();
    }

    mapped.usuarioAutenticado.cpfCnpj = alterarCampoCpfComBaseNoLoginAD(mapped);
    return mapped;
}
